export type WorkspaceTab = "to-do" | "logs" | "events";

/**
 * The Workspace tab to show for a `?tab=` value. Events is hidden from roles
 * that can't report, so their `?tab=events` lands on To do (NAU-442).
 */
export function resolveWorkspaceTab(
  tab: string | undefined,
  canReportEvents: boolean,
): WorkspaceTab {
  if (tab === "logs") return "logs";
  if (tab !== "events") return "to-do";
  if (!canReportEvents) return "to-do";
  return "events";
}
